import { render, staticRenderFns } from "./SingleNft.vue?vue&type=template&id=55b059c4"
import script from "./SingleNft.vue?vue&type=script&lang=js"
export * from "./SingleNft.vue?vue&type=script&lang=js"
import style0 from "./SingleNft.vue?vue&type=style&index=0&id=55b059c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports